module.exports = __webpack_public_path__ + "static/media/photo-of-a-woman.733e3164.jpg";